import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const PreviousBar = (props) => {
  const navigate = useNavigate()
 
  return (
    <div className="sticky top-13 my-2 text-base w-auto text-[#b3853e] px-2 py-2 h-auto bg-[#f8eede] rounded  flex justify-between z-0">
      <button className="mr-4" type="button" onClick={() => 
        props.toDashboard ? navigate("/dashboard") :navigate(-1) }>
      <ArrowBackIosIcon/>
        {/* {getIconFontawesome("arrowLeftSolid", "lg")} */}
      </button>
      <div className={`uppercase ml-x2rem`}>{props.name}</div>
      {/* {router.pathname == '/deposit' ? <Popup textName={"วิธีฝาก"} metaPopUp={props.metaPopUp} pageName={"วิธีการฝากเงิน"} /> : <div></div>} */}
      <div></div>

    </div>
  );
};

export default PreviousBar;
